import { render, staticRenderFns } from "./zhibiao.vue?vue&type=template&id=14e28303&scoped=true"
import script from "./zhibiao.vue?vue&type=script&lang=js"
export * from "./zhibiao.vue?vue&type=script&lang=js"
import style0 from "./zhibiao.vue?vue&type=style&index=0&id=14e28303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e28303",
  null
  
)

export default component.exports